module.exports = "/static/fonts/OpenSans-Light.eot";